function displayReadingTime(articleElement, displayElement) {

  const countWords = (articleElement) => {
    // Get text content from the article element
    const text = articleElement.textContent || articleElement.innerText;

    // Split the text into words and count them
    const words = text.split(/\s+/);
    return words.length;
  }
  
  const calculateReadingTime = (wordsCount) => {
      const wordsPerMinute = 200; // Average reading speed
      const minutes = wordsCount / wordsPerMinute;
  
      // Round up to the nearest minute
      return Math.ceil(minutes);
  }
  const wordsCount = countWords(articleElement);
  const readingTime = calculateReadingTime(wordsCount);
  // Display the estimated time
  displayElement.textContent = readingTime + " minute read";
}

document.addEventListener("DOMContentLoaded", function() {
    const articleElement = document.querySelector('[itemprop="articleBody"]'); // Replace with your article element ID
    const displayElement = document.getElementById("reading-time"); // Replace with your display element ID

    displayReadingTime(articleElement, displayElement);
});

function displayReadingTime(articleElement, displayElement) {

  const countWords = (articleElement) => {
    // Get text content from the article element
    const text = articleElement.textContent || articleElement.innerText;

    // Split the text into words and count them
    const words = text.split(/\s+/);
    return words.length;
  }
  
  const calculateReadingTime = (wordsCount) => {
      const wordsPerMinute = 200; // Average reading speed
      const minutes = wordsCount / wordsPerMinute;
  
      // Round up to the nearest minute
      return Math.ceil(minutes);
  }
  const wordsCount = countWords(articleElement);
  const readingTime = calculateReadingTime(wordsCount);
  // Display the estimated time
  displayElement.textContent = readingTime + " minute read";
}

document.addEventListener("DOMContentLoaded", function() {
    const articleElement = document.querySelector('[itemprop="articleBody"]'); // Replace with your article element ID
    const displayElement = document.getElementById("reading-time"); // Replace with your display element ID

    displayReadingTime(articleElement, displayElement);
});

